import React from 'react';
import { useLocation } from 'react-router-dom';
import { getLangFromPath, t, Lang } from '../utils/i18n';
import './Footer.css';

const Footer: React.FC = () => {
  const location = useLocation();
  const lang = getLangFromPath(location.pathname, 'en');
  const isRtl = lang === 'ar';

  return (
    <footer className="footer" itemScope itemType="https://schema.org/WPFooter">
      <div className="footer-content">
        <p className="footer-text">© 2025 Damascus Gin. All rights reserved. Please drink responsibly.</p>
        <p
          className={`powered-by${isRtl ? ' powered-by--rtl' : ''}`}
          dir={isRtl ? 'rtl' : 'ltr'}
        >
          <span className="powered-by-label">{t(lang as Lang, 'footer.powered')}</span>
          <a
            href="https://elyptek.com"
            className="elyptek-link"
            target="_blank"
            rel="author noopener noreferrer"
            dir="ltr"
            aria-label={t(lang as Lang, 'footer.brandAria')}
            itemProp="author"
          >
            <span className="elyptek-part elyptek-part--dark">Elyp</span>
            <span className="elyptek-part elyptek-part--orange">tek</span>
            <span className="elyptek-part elyptek-part--dark">™</span>
          </a>
        </p>
        <p className="footer-credit-plain">
          {t(lang as Lang, 'footer.siteCredit')}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
